<div mat-dialog-title>
  <span class="title-icon">
    <ui-icon faName="circle-user-circle-xmark" faStyle="light"></ui-icon>
  </span>

  <div>
    <h6>{{ title }}</h6>
    <p class="subtitle">{{ subtitle }}</p>
  </div>
</div>

<mat-dialog-content>
  <div class="message">
    <ui-icon faName="circle-info" faStyle="light"></ui-icon>
    <p>
      {{ messageBeforePhone }}
      <a [href]="'tel:' + supportPhoneHref">{{ supportPhoneLabel }}</a>
      {{ messageBeforeEmail }}
      <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
      {{ messageAfterEmail }}
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="support-container">
    <ui-icon faName="circle-question" faStyle="light"></ui-icon>
    <div>
      <p class="support-title">{{ supportTitle }}</p>
      <p class="support-subline">{{ supportText }}</p>
    </div>
  </div>

  <ui-button-link [link]="helpdeskLink" buttonStyle="outlined">
    <ui-icon faName="user-headset" faStyle="light"></ui-icon>
    <span>{{ helpdeskLabel }}</span>
  </ui-button-link>
</mat-dialog-actions>
